import { Routes, Route } from 'react-router-dom'

import QRARoutes from './QRA'
import Assessments from './Assessments'

/**
 * QRA view props as in current/saved state system/line view props.
 */
export interface IQRAViewProps {
  qraBasePath: string
}

const RiskManagement = (): JSX.Element => {
  return (
    <Routes>
      <Route path='qra/*' element={<QRARoutes />} />
      <Route path='assessments/*' element={<Assessments />} />
      <Route path='*' element={<QRARoutes />} />
    </Routes>
  )
}

export default RiskManagement
